<script>
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import AltTable from "./AltTableOlgunluk.vue";
import StrIcDegerTablo from "@/models/StrIcDegerTablo";
export default {
  mixins: [Api, Sabit, StrIcDegerTablo],
  props: ["UstId", "UpdateAltTable"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      TableData: [],
    };
  },
  components: {
    AltTable,
  },
  watch:{
    UpdateAltTable(){
      if(this.UpdateAltTable == true){
        this.Get();
      }
    }
  },
  methods: {
    Get() {
      let Filter = "&Ustid=" + this.UstId + "&Seviye=1&Asc=SiraNo";
      this.ActionsFilterGet({ Service: "StrIcDegerTablo", Page: this.Page, Filter: Filter }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
        this.$emit("UpdateAltTable");
      });
    },
  },
};
</script>
<template>
  <div>
    <table class="table table-striped table-bordered mb-0">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">
            {{ $t("StrIcDegerTablo.Table.SiraNo") }}
          </th>
          <th scope="col">
            {{ $t("StrIcDegerTablo.Table.TabloAdi") }}
          </th>
          <th scope="col" >
            {{ $t("StrIcDegerTablo.Table.Aktif") }}
          </th>
          <th scope="col" >
            {{ $t("StrIcDegerTablo.Table.Islem") }}
          </th>
        </tr>
      </thead>
      <tbody v-for="TableDataVerileri in TableData" :key="TableDataVerileri.Id">
        <tr>
          <th scope="row" class="custom-accordion">
            <a
              class="
                          text-body
                          fw-medium
                          py-1
                          d-flex
                          align-items-center
                        "
              data-toggle="collapse"
              v-b-toggle="'CollapseAltTablo2' + TableDataVerileri.Id"
              role="button"
              aria-expanded="false"
              aria-controls="categories-collapse"
            >
              <i class="mdi mdi-chevron-up accor-down-icon ms-auto"></i>
            </a>
          </th>
          <td>{{ TableDataVerileri.Sirano }}</td>
          <td>{{ TableDataVerileri.Tabloadi }}</td>
          <td >
              <i v-if="TableDataVerileri.Aktif" class="fas fas fa-check"></i>
              <i v-if="!TableDataVerileri.Aktif" class="fas fas fa-times"></i>
          </td>
          <td >
              <b-button-group>
                <b-button variant="success" v-b-modal.StrIcDegerTablo @click="$emit('Seviye', 2), $emit('AddEdit', 'Add'), $emit('DataUpdate', StrIcDegerTabloData), $emit('UstId', TableDataVerileri.Id)"><i class="fa fa-plus"></i></b-button>
                <b-button variant="primary" v-b-modal.StrIcDegerTablo @click="$emit('Seviye', TableDataVerileri.Seviye), $emit('AddEdit', 'Edit'), $emit('DataUpdate', TableDataVerileri)"><i class="fa fa-pencil-alt"></i></b-button>
                <b-button variant="danger" @click="Delete('StrIcDegerTablo', TableDataVerileri.Id)"><i class="fa fa-trash-alt"></i></b-button>
              </b-button-group>
          </td>
        </tr>
        <tr>
          <td colspan="5">
            <b-collapse class="collapse show p-3" :id="'CollapseAltTablo2' + TableDataVerileri.Id">
              <AltTable :UstId="TableDataVerileri.Id" @AddEdit="$emit('AddEdit', $event)" @Seviye="$emit('Seviye', $event)" @DataUpdate="$emit('DataUpdate', $event)" @UstId="$emit('UstId', $event)" @Icdegerid="$emit('Icdegerid', $event)" :UpdateAltTable="UpdateAltTable" @UpdateAltTable="UpdateAltTable = false" />
            </b-collapse>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
